<script setup>
import BaseDialog from "@/base-components/Dialog/BaseDialog.vue";
import Button from "@/base-components/Button";
import {uri} from "@/constants/config";
import {Form} from "vee-validate";
import {computed, ref} from "vue";
import {useFetch} from "@/composables/useFetch";
import {useI18n} from "vue-i18n";
import {Tab} from "@/base-components/Headless";

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  pricing: {
    required: true,
  }
})
console.log(props.pricing.value);
const {t: $t} = useI18n()
const isLoadingFlag = ref(false)
const emit = defineEmits(['close', 'onSuccess']);
const paymentCycle = ref('1')

function close() {
  emit('close')
}

const requestParams = ref({
  amount: null,
  id: null,
})

async function updatePricing() {
  try {
    const {data} = await useFetch(uri.admin.cloud.updateCloudPricing(props.pricing.regionId, props.pricing.Overrides[0].id), {
      method: "PATCH",
      body: {pricePlan:props.pricing.Overrides[0].pricePlan}
    });
    if (data) {
      emit("onSuccess")
    }
  } catch (err) {
    console.log(err)
  } finally {
    isLoadingFlag.value = false
  }
}

// Computed functions to handle dynamic price plans
const getCurrentPricePlan = (item) => {
  return computed(() =>
      item.Overrides[0].pricePlan.value.find((option) => option.key === paymentCycle.value)?.value || []
  );
};

const getCurrentBasePrice = (item) => {
  return computed(() =>
      item.pricePlan.value.find((option) => option.key === paymentCycle.value)?.value || []
  );
};

function updatePrice(item, key, newPrice) {
  const pricePlan = getCurrentPricePlan(item).value;
  const priceItem = pricePlan.find((plan) => plan.key === key);
  if (priceItem) priceItem.price = parseInt(newPrice);
}


</script>

<template>
  <section>
    <BaseDialog
        :size="'lg'"
        staticBackdrop
        :open="show"
        :has-footer="true"
        :title="pricing.assetName+' '+(pricing.Network?pricing.Network?.displayName??'':'')"
        @close="close"
    >
      <div class="rounded-md px-2 py-2 w-full max-h-[78vh] overflow-auto mb-3">

        <Tab.Group class="max-h-full col-span-12 xl:col-span-8 md:col-span-6 lg:col-span-6 ">
          <div class="top-0 pb-3 xl:sticky">
            <Tab.List
                variant="pills"
                class="p-1 mx-auto mt-3 border border-dashed rounded-md border-slate-300 dark:border-darkmode-300"
            >
              <Tab v-for="value in ['1','3','6','12']" :key="value">
                <Tab.Button
                    as="button"
                    class="w-full py-1.5 px-2"
                    :class="{ active: paymentCycle === value }"
                    @click="paymentCycle = value"
                >
                  {{ value }} {{ $t('title.month') }}
                </Tab.Button>
              </Tab>
            </Tab.List>
          </div>
        </Tab.Group>
        <Form id="myForm" @submit="updatePricing">
          <div class="grid grid-cols-1  ">

            <div
                class="col-span-12 xl:col-span-4 md:col-span-6 lg:col-span-6 p-3 box shadow-md rounded-lg"
            >

              <!-- Table -->
              <table class="table-auto w-full border-collapse border border-gray-200 rounded-md">
                <thead class="bg-gray-100">
                <tr>
                  <th class="border px-4 py-1">{{ $t("title.value") }}</th>
                  <th class="border px-4 py-1">{{ $t("title.base-price") }}</th>
                  <th class="border px-4 py-1">{{ $t("title.sale-price") }}</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(plan, index) in getCurrentPricePlan(pricing).value"
                    :key="index"
                >
                  <td class="border px-4 py-1 text-center text-xs">{{ plan.key }}</td>
                  <td class="border px-4 py-1 text-center text-xs">
                    {{ getCurrentBasePrice(pricing).value[index]?.price || '-' }}
                  </td>
                  <td class="border px-4 py-2 text-center">
                    <input
                        type="number"
                        class="w-full px-3 text-xs h-8 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
                        :value="plan.price"
                        @input="updatePrice(pricing, plan.key, $event.target.value)"
                    />
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Form>
      </div>

      <template v-slot:footer>
        <div class="flex col-md-12 items-end justify-end gap-2">
          <Button variant="outline-secondary" @click="close" size="sm" class=" shadow-md justify-end items-end">
            {{ $t('button.cancel') }}
          </Button>
          <Button variant="primary" size="sm" form="myForm" class=" shadow-md justify-end items-end">
            {{ $t('button.update') }}
          </Button>
        </div>
      </template>

    </BaseDialog>
  </section>
</template>

<style scoped>

</style>